import * as attachments from '@wix/auto_sdk_crm_attachments';
import * as contacts from '@wix/auto_sdk_crm_contacts';
import * as extendedFields from '@wix/auto_sdk_crm_extended-fields';
import * as labels from '@wix/auto_sdk_crm_labels';
import * as submittedContact from '@wix/auto_sdk_crm_submitted-contact';
import * as notes from '@wix/auto_sdk_crm_notes';
import * as cards from '@wix/auto_sdk_crm_cards';
import * as pipelines from '@wix/auto_sdk_crm_pipelines';
import * as tasks from '@wix/auto_sdk_crm_tasks';

export {
  attachments,
  contacts,
  extendedFields,
  labels,
  submittedContact,
  notes,
  cards,
  pipelines,
  tasks,
};
